var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},_vm._l((_vm.count),function(i){return _c('div',{key:i,staticClass:"program-loader course-detail-loader mb-3"},[_c('VueSkeletonLoader',{attrs:{"type":"rect","width":1100,"height":10,"rounded":"","animation":"fade","color":"#dddddd"}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }